import { render, staticRenderFns } from "./egpaybank.vue?vue&type=template&id=5136c1fd"
import script from "./egpaybank.vue?vue&type=script&lang=js"
export * from "./egpaybank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports